export function useJoinPic(image1: File, image2: File): Promise<File> {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      reject(new Error("canvas error"));
      return;
    }

    canvas.width = 800;
    canvas.height = 400;

    const img1 = new Image();
    const img2 = new Image();

    let loadedImages = 0;

    function drawImages() {
      // 裁剪并绘制第一张图片
      const croppedWidth = 400;
      const croppedHeight = 400;

      let x1 = 0;
      let y1 = 0;
      let croppedWidth1 = 0;
      let croppedHeight1 = 0;
      if (Math.min(img1.width, img1.height) < croppedWidth) {
        croppedWidth1 = Math.min(img1.width, img1.height);
        croppedHeight1 = Math.min(img1.width, img1.height);
        x1 = img1.width > croppedWidth1 ? (img1.width - croppedWidth1) / 2 : 0;
        y1 =
          img1.height > croppedHeight1 ? (img1.height - croppedHeight1) / 2 : 0;
      } else {
        x1 = (img1.width - croppedWidth) / 2;
        y1 = (img1.height - croppedHeight) / 2;
        croppedWidth1 = croppedWidth;
        croppedHeight1 = croppedHeight;
      }
      ctx!.drawImage(
        img1,
        x1,
        y1,
        croppedWidth1,
        croppedHeight1,
        0,
        0,
        400,
        400,
      );

      // 裁剪并绘制第二张图片
      let x2 = 0;
      let y2 = 0;
      let croppedWidth2 = 0;
      let croppedHeight2 = 0;
      if (Math.min(img2.width, img2.height) < croppedWidth) {
        croppedWidth2 = Math.min(img2.width, img2.height);
        croppedHeight2 = Math.min(img2.width, img2.height);
        x2 = img2.width > croppedWidth2 ? (img2.width - croppedWidth2) / 2 : 0;
        y2 =
          img2.height > croppedHeight2 ? (img2.height - croppedHeight2) / 2 : 0;
      } else {
        x2 = (img2.width - croppedWidth) / 2;
        y2 = (img2.height - croppedHeight) / 2;
        croppedWidth2 = croppedWidth;
        croppedHeight2 = croppedHeight;
      }
      ctx!.drawImage(
        img2,
        x2,
        y2,
        croppedWidth2,
        croppedHeight2,
        400,
        0,
        400,
        400,
      );

      canvas.toBlob((blob) => {
        if (blob) {
          resolve(
            new File([blob], "image.png", {
              type: blob.type,
            }),
          );
        } else {
          reject(new Error("blob error"));
        }
      }, "image/png");
    }

    function onImageLoad() {
      loadedImages++;
      if (loadedImages === 2) {
        drawImages();
      }
    }

    img1.onload = onImageLoad;
    img2.onload = onImageLoad;

    img1.onerror = () => reject(new Error("load pic1 error"));
    img2.onerror = () => reject(new Error("load pic2 error"));

    img1.src = URL.createObjectURL(image1);
    img2.src = URL.createObjectURL(image2);
  });
}
